export class CompanyAlreadyRegisteredError extends Error {
  constructor() {
    super("The provided details are already registered.");
    // super(message);
    this.name = "CompanyAlreadyRegisteredError";
  }
}
